import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { findPrice } from '@epicuro-next/ataraxia/product-price';
import { dynamicElementsProductCardHeader } from '@epicuro-next/constants/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { Product, ProductPriceRanges } from 'graphql-api/gql-api-interfaces';

@DynamicComponentRegister(dynamicElementsProductCardHeader, true)
@Component({
  selector: 'atx-product-card-header',
  styleUrls: ['./product-card-header.component.scss'],
  templateUrl: './product-card-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductCardHeaderComponent {
  @Input() public product: Product;
  @Input() public showMarkup = true;
  @Input() public compactView = false;
  @Input() public idFields: string[] = ['displayedProductId'];
  @Input() public titleFields: string[] = ['articleTitle'];
  @Input() public titlePrefixFields: string[] = [];
  @Input() public showWspdPrice = false;
  @Input() public showWholeSalePrice = true;
  @Input() public isSearchV2Enabled = false;
  @Input() public showProductTitle = true;
  @Input()
  public set prices(value: ProductPriceRanges[]) {
    value = value ?? [];
    const price = findPrice(value);

    if (!this.showWspdPrice) {
      this.price = {
        ...price,
        wspd: null,
      };
    } else {
      this.price = price;
    }
  }

  public price: ProductPriceRanges | null = null;
}
